import {prospectusGraphql} from '../api'; //prospectusUrl
// import {verifyRecaptcha} from '../helpers'

const registerUser = ({username, email, password}) => async(dispatch) => {

	// const result = await verifyRecaptcha( prospectusUrl(), 'register' );

	// Do the recaptcha request here.
	// if ( ! result ) {
	// 	dispatch({
	// 		type : 'FAILED_REGISTER',
	// 		payload : [
	// 			'oh no, looks like you failed the bot check.'
	// 		],
	// 	})
	// }

	const response = await fetch( prospectusGraphql(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(
            { query: `
			mutation RegisterUser {
				registerUser(
					input: {
						clientMutationId: "registerId",
						username: "${username}",
						password: "${password}",
						email: "${email}"
					}) {
					user {
						jwtAuthToken
						jwtRefreshToken
					}
				}
			}`
        }),
	})

	let data = await response.json()

	if ( data.errors ) {

		dispatch({
			type : 'FAILED_REGISTER',
			payload : [
				data.errors[0].message
			],
		})

	} else {

		dispatch({
			type : 'USER_REGISTER',
			payload : data.data.registerUser.user,
		})

		dispatch({ type: 'NO_PREVIOUS' })
	}
}

export default registerUser;